import { Component, Input, OnInit } from '@angular/core';
import { NgToastService } from './ng-toast.service';
import { IToast, Message, Position } from './toast.model';

@Component({
  selector: 'ng-toast',
  templateUrl: './ng-toast.component.html',
  styleUrls: ['./ng-toast.component.scss'
  ]
})
export class NgToastComponent implements OnInit {

  show: boolean = false;
  @Input() style: any = {

  };
  toastDetails: IToast | undefined;
  timeoutRef: any;
  constructor(private toastService: NgToastService) { }

  ngOnInit(): void {
    this.toastService.getToastDetails().subscribe((val: IToast) => {
      this.show = true;
      clearTimeout(this.timeoutRef);
      this.toastDetails = val;
      if (this.toastDetails.duration) {
        this.timeoutRef = setTimeout(() => { // duration is there
          this.show = false;
        }, this.toastDetails.duration);
      }
      if (this.toastDetails.sticky) { // for sticky
        clearTimeout(this.timeoutRef);
        this.show = true;
      }
      if (!this.toastDetails.duration && !this.toastDetails.sticky) { //no duration and sticky is true
        this.timeoutRef = setTimeout(() => {
          this.show = false;
        }, 4000);
      }
    });
  }
  closeToast() {
    clearTimeout(this.timeoutRef);
    this.show = false;
  }
  loadPosition() {
    let postionClass = "";
    if (this.toastDetails?.position !== undefined) {
      switch (this.toastDetails.position) {
        case "topRight": postionClass = 'toast-top-right';
          break;
        case "topLeft": postionClass = 'toast-top-left';
          break;
        case "bottomRight": postionClass = 'toast-bottom-right';
          break;
        case "bottomLeft": postionClass = 'toast-bottom-left';
          break;
        case "topCenter": postionClass = 'toast-top-center';
          break;
        case "botomCenter": postionClass = 'toast-bottom-center';
          break;
        default: postionClass = "toast-top-right";
      }
    } else {
      postionClass = "toast-top-right"
    }
    return postionClass;
  }
  loadMessageType() {
    let typeClass = "";
    if (this.toastDetails?.type !== undefined) {
      switch (this.toastDetails.type) {
        case "success": typeClass = Message.success;
          break;
        case "error": typeClass = Message.error;
          break;
        case "warning": typeClass = Message.warning;
          break;
        case "info": typeClass = Message.info;
          break;

        default: typeClass = Message.success;
      }
    } else {
      typeClass = Message.success;
    }
    return typeClass;
  }

  loadIconType() {
    let iconClass = "";
    if (this.toastDetails?.type !== undefined) {
      switch (this.toastDetails.type) {
        case "success": iconClass = 'fa-check-circle';
          break;
        case "error": iconClass = 'fa-times-circle';
          break;
        case "warning": iconClass = 'fa-exclamation-circle';
          break;
        case "info": iconClass = 'fa-info-circle';
          break;

        default: iconClass = "fa-check-circle";
      }
    } else {
      iconClass = "fa-check-circle"
    }
    return iconClass;
  }

}
